import type { ShellAuthApplicationPort } from '../../../../shared/app-context/domain/ports/ShellAuthApplicationPort.ts';
import type { ShellNavigationPort } from '../../../../shared/app-context/domain/ports/ShellNavigationPort.ts';
import { SHELL_PERMISSION_SYNC } from '../../../../shared/app-context/domain/shellModulePermissions.ts';
import type { CoreShellPorts } from '../../../../shared/routing/domain/CoreShellPorts.ts';
import type { PresentationShellPort } from '../../../../shared/presentation/application/ports/PresentationShellPort.ts';
import { createShellPermissionMainPageRoute } from '../../../../shared/routing/infrastructure/drivers/routes/shellRouteGuards.ts';

export function createSyncRoute<T extends CoreShellPorts>(
  auth: ShellAuthApplicationPort,
  navigation: ShellNavigationPort,
  presentation: PresentationShellPort<T>,
  shellPorts: T,
): () => Promise<void> {
  return createShellPermissionMainPageRoute(
    auth,
    navigation,
    presentation,
    SHELL_PERMISSION_SYNC,
    'sync',
    () => import('./SyncPageComponent.ts'),
    shellPorts,
  );
}
